// tslint:disable: prefer-for-of
// tslint:disable: no-unused-expression
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertController, MenuController, PopoverController } from '@ionic/angular';
import { ProductoMensajePopoverComponent } from 'src/app/components/productoMensajePopover/producto-mensaje-popover.component';
import { CarritoService } from 'src/app/services/carrito/carrito.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { ProductoService } from 'src/app/services/producto/producto.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { SucursalService } from 'src/app/services/sucursal/sucursal.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';

import { Plugins } from '@capacitor/core';
import { ISucursal } from 'src/app/interfaces/ISucursal';
import { IPedido } from 'src/app/interfaces/IPedido';
import { VentaService } from 'src/app/services/venta/venta.service';
const { Geolocation } = Plugins;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;
  public _total: number = 0;
  public _mostrarProductos: number = 3;
  public _tienda: boolean = false;
  public _domi: boolean = true;

  public _listProduct: any;
  public _nameUser: string;

  public paymentAmount: string = '97.50';
  public currency: string = 'MXN';
  public currencyIcon: string = '$';
  private pedido: any;

  public _municipio: string;
  public _latitude: string;
  public _longitude: string;
  public _domicilio: string;

  private IEPSMonto: number = 0;
  private IEPSPorcentaje: number = 0;
  private IVAMonto: number = 0;
  private IVAPorcentaje: number = 0;
  private SubtotalAntesDeImpuestos: number = 0;
  private Total: number = 0;
  public _allSucursalesPorUbicacion: Array<ISucursal> = [];

  private _latitud: number;
  private _longitud: number;

  public _sucursal: any;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _carritoSrv: CarritoService,
              private _alertCtrl: AlertController,
              private _ventaSrv: VentaService,
              private _globalFunctionsSrv: GlobalFunctionsService,
              private _storageSrv: StorageService,
              private _deviceInfoSrv: DeviceInfoService,
              private _sucursalSrv: SucursalService,
              private _router: Router, ) {

    console.log('CarritoPage >> constructor');
    this._listProduct = [];
    this._nameUser = this._storageSrv.getNombre();

    const _this = this;
    setTimeout(() => {

      // Render the PayPal button into #paypal-button-container
      window['paypal'].Buttons({
        // Set up the transaction
        createOrder: (data, actions) => {

          console.log('PayPal.createOrder');
          console.log(data);
          console.log(actions);

          let validForm = true;
          if (this._domi && !this._domicilio) {
            validForm = false;
            this._globalFunctionsSrv.showMessageToast('Debe ingresar el domicilio para entregar su pedido.');
          }
          console.log('valido: ' + validForm);
          if (validForm) {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: _this.paymentAmount
                }
              }]
            });
          }

        },

        // Finalize the transaction
        onApprove: (data, actions) => {

          console.log('PayPal.onApprove');
          console.log(data);
          console.log(actions);

          this._globalFunctionsSrv.showLoader();
          return actions.order.capture()
            .then((details) => {

              console.log(details);

              // Show a success message to the buyer
              let tipoPedido = '';
              if (this._tienda) {
                tipoPedido = 'PIC';
              }
              else {
                tipoPedido = 'DOM';
              }

              // construye estructura para registar un carro de compras
              const newPedido: IPedido = {
                IdSucursal: this.pedido.IdSucursal,
                Cantidad: this.pedido['Productos'].length,
                IdCarrito: this.pedido['IdCarrito'],
                IdPaypal: details['id'],
                DeviceInfo: this._deviceInfoSrv.CurrentDeviceInfo,
                IEPSMonto: this.IEPSMonto,
                IEPSPorcentaje: this.IEPSPorcentaje,
                IVAMonto: this.IVAMonto,
                IVAPorcentaje: this.IVAPorcentaje,
                SubtotalAntesDeImpuestos: this.SubtotalAntesDeImpuestos,
                Total: this.Total,
                Municipio: this._municipio,
                Domicilio: this._domicilio,
                Latitude: this._latitude,
                Longitude: this._longitude,
                IdTipoPedido: tipoPedido,
                IdUsuarioWeb: this._storageSrv.getIdUsuario(),
                NombreCliente: this._storageSrv.getNombre(),
              };
              console.log('Guardar Venta >> ');
              console.log(newPedido);

              this._ventaSrv.guardar(newPedido).subscribe(() => {
                const res: number = this._ventaSrv.VentaConfirmada;
                console.log('VentaConfirmada >> ' + res);
              });

              this._globalFunctionsSrv.hideLoader();
              this._router.navigate(['/account']);
              this._globalFunctionsSrv.showMessageToast('Su pago ha sido validado exitósamente, su pedido ha quedado completado.');
            })
            .catch(err => {
              this._globalFunctionsSrv.hideLoader();
              this._globalFunctionsSrv.showMessageToast('Ha ocurrido un error tratando de realizar su pago, intente de nuevo.');

              console.log('PayPal Error >> ');
              console.log(err);
              console.log(data);
              console.log(actions);

            });
        }
      }).render('#paypal-button-container') as any;
    }, 500);

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('CarritoPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('CarritoPage >> ionViewDidEnter');

    const position = await Geolocation.getCurrentPosition({timeout: 30000, enableHighAccuracy: true});
    this._latitud = position.coords.latitude;
    this._longitud = position.coords.longitude;

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    this._usuarioSrv.getLocation()
    .then((res) => {
      console.log('domicilio guardado');
      console.log(res);
      this._municipio = res['Address'];
      this._latitude = res['Latitude'];
      this._longitude = res['Longitude'];
    });

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('CarritoCompras', null, null,
        null, null, null, null,
        null, null,
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
      this.getCarrito();
    });
    this._domicilio = this._storageSrv.getDomicilio();
  }

  public async getCarrito(){
    this._carritoSrv.getCarritoWeb().subscribe(() => {
      console.log('desde web el carrito');
      console.log(this._carritoSrv.CurrentCarrito);
      console.log(this._carritoSrv.CurrentCarrito['Productos']);
      this.pedido = this._carritoSrv.CurrentCarrito;
      this._listProduct = this._carritoSrv.CurrentCarrito['Productos'];

      if (this._listProduct.length > 0) {

        for (let i = 0; i < this._listProduct.length; i++){
          this.IEPSMonto = parseFloat(this.IEPSMonto.toString()) + parseFloat(this._listProduct[i]['IEPSMonto']);
          this.IEPSPorcentaje = parseInt(this.IEPSPorcentaje.toString(), 10) + parseInt(this._listProduct[i]['IEPSPorcentaje'], 10);
          this.IVAMonto = parseInt(this.IVAMonto.toString(), 10) + parseInt(this._listProduct[i]['IVAMonto'], 10);
          this.IVAPorcentaje = parseInt(this.IVAPorcentaje.toString(), 10) + parseInt(this._listProduct[i]['IVAPorcentaje'], 10);
          this.SubtotalAntesDeImpuestos = parseInt(this.SubtotalAntesDeImpuestos.toString(), 10) + parseInt(this._listProduct[i]['SubtotalAntesDeImpuestos'], 10);
          this.Total = parseInt(this.Total.toString(), 10) + parseInt(this._listProduct[i]['Subtotal'], 10);
        }
      }

      this._sucursalSrv.getAllSucursales().subscribe(() => {
        const _sucursales = this._sucursalSrv.AllSucursales;
        console.log(_sucursales);
        _sucursales.forEach(itemSucursal => {
          if (itemSucursal.Lat && itemSucursal.Lng){
            const km = this._globalFunctionsSrv.distanceToPlace(this._latitud, this._longitud, itemSucursal.Lat, itemSucursal.Lng, 'K');
            if (km < 30){
              this._allSucursalesPorUbicacion.push(
                {
                  IdSucursal: itemSucursal.IdSucursal,
                  Nombre: itemSucursal.Nombre,
                  Distancia: km,
                  DistanciaText: km.toFixed(2)
                });
            }
          }
        });
        this._sucursal = this.pedido['IdSucursal'];

      });

      // Aqui
      this._total = this._carritoSrv.CurrentCarrito['Total'];
      this.paymentAmount = this._carritoSrv.CurrentCarrito['Total'];
      if (this._listProduct && this._listProduct.length > 0){
        this._mostrarProductos = 1;
      }
      else{
        this._mostrarProductos = 0;
      }
    });

  }

  public checkPickup(num, val){
    if (num == 1){
      this._domi = false;
      this._domicilio = '';
    }
    else if (num == 2){
      this._tienda = false;
    }
  }

  public validaCarito(){
    if (this._listProduct.length > 0){
      this._mostrarProductos = 1;
    }
    else{
      this._mostrarProductos = 0;
    }
  }

  //#endregion Eventos NG|

  //#region Eventos Botones

  //#endregion

}
